import axios from "axios";

const apiRPA = axios.create({
    baseURL: process.env.REACT_APP_API_RPA_URL
});

apiRPA.interceptors.request.use(async config => {
    return config;
});

apiRPA.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        return Promise.reject(error);
    }
);

export default apiRPA;